import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import colors, { grays } from 'app/constants/colors';
import DarkLogo from '../DarkLogo';
import { Link } from 'react-router-dom';
import LightLogo from '../LightLogo';
import { desktopMinWidth } from '../../../utils/windowHelpers';
import InstagramIcon from '../icons/SocialIcons/InstagramIcon';
import TiktokIcon from '../icons/SocialIcons/TiktokIcon';
import TwitterIcon from '../icons/SocialIcons/TwitterIcon';
import DiscordIcon from '../icons/SocialIcons/DiscordIcon';
import { useWindowWidthContext } from '../../contexts/WindowWidthContext';
import OpenseaIcon from '../icons/SocialIcons/OpenseaIcon';

const Footer = ({ lightTheme = false, blueTheme = false }) => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        background: blueTheme ? colors.darker_blue : colors.black_33,
        textAlign: 'center',
        paddingLeft: 0,
        paddingBottom: 40,
        maxWidth: 1440,
        width: '90%',
        [desktopMinWidth]: {
          flexDirection: 'row',
          justifyContent: 'space-between',
          paddingBottom: 24,
          paddingTop: 40,
        },
      },
      footerTop: {
        flex: 2,
        paddingTop: 40,
        paddingBottom: 12,
        background: lightTheme
          ? colors.white
          : blueTheme
          ? colors.darker_blue
          : colors.black_33,
        [desktopMinWidth]: {
          paddingTop: 0,
          paddingBottom: 0,
        },
      },
      logo: {
        [desktopMinWidth]: {
          textAlign: 'left',
        },
      },
      socialLink: {
        fontSize: 14,
        textDecoration: 'none',
        margin: 0,
      },
      footerBottom: {
        flex: 1,
        textAlign: 'left',
      },
      footerBottomFlex: {
        display: 'flex',
      },
      link: {
        textDecoration: 'underline',
        marginRight: 16,
      },
      footerText: {
        color: lightTheme
          ? colors.black_44
          : blueTheme
          ? colors.white_f2
          : colors.light_white_e2,
        fontSize: 14,
        marginTop: 12,
        textAlign: 'left',
        fontWeight: 500,
        [desktopMinWidth]: {
          fontSize: 16,
        },
      },
      footerTextSmall: {
        fontSize: 12,
        [desktopMinWidth]: {
          fontSize: 14,
        },
      },
      footerLink: {
        marginRight: 12,
      },
      copyRight: {
        color: lightTheme
          ? colors.black_44
          : blueTheme
          ? colors.white_f2
          : colors.light_white_e2,
        lineHeight: 1.5,
        fontSize: 10,
        textAlign: 'center',
        [desktopMinWidth]: {
          fontSize: 12,
          textAlign: 'left',
        },
      },
      iconsContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [desktopMinWidth]: {
          justifyContent: 'flex-start',
        },
      },
      socialLogo: {
        marginRight: 12,
      },
    }),
  );
  const classes = useStyles();
  const { isDesktopView } = useWindowWidthContext();

  const socialLogos = lightTheme
    ? [
        {
          logo: <InstagramIcon color={colors.gray_66} />,
          link: 'https://www.instagram.com/nasacademycrypto/',
        },
        {
          logo: <TwitterIcon color={colors.gray_66} />,
          link: 'https://mobile.twitter.com/nasacademy',
        },
        {
          logo: <TiktokIcon color={colors.gray_66} />,
          link: 'https://www.tiktok.com/@nasacademy_crypto',
        },
        {
          logo: <DiscordIcon color={colors.gray_66} />,
          link: 'https://discord.com/invite/catc',
        },
        {
          logo: <OpenseaIcon color={colors.gray_66} />,
          link:
            'https://opensea.io/collection/nas-academy-x-curious-addys-zombie-edition',
        },
      ]
    : [
        {
          logo: <InstagramIcon />,
          link: 'https://www.instagram.com/nasacademycrypto/',
        },
        {
          logo: <TwitterIcon />,
          link: 'https://mobile.twitter.com/nasacademy',
        },
        {
          logo: <TiktokIcon />,
          link: 'https://www.tiktok.com/@nasacademy_crypto',
        },
        {
          logo: <DiscordIcon />,
          link: 'https://discord.com/invite/catc',
        },
        {
          logo: <OpenseaIcon />,
          link:
            'https://opensea.io/collection/nas-academy-x-curious-addys-zombie-edition',
        },
      ];

  return (
    <footer className={classes.root}>
      {!isDesktopView && (
        <div className={`${classes.footerBottom} ${classes.footerBottomFlex}`}>
          <div className={classes.footerLink}>
            <a
              href="https://nas-academy.gitbook.io/nas-io/"
              rel="noopener noreferrer"
              target="_blank"
              className={`${classes.footerText} ${classes.socialLink} ${classes.footerTextSmall}`}
            >
              Documentation
            </a>
          </div>
          <div className={classes.footerLink}>
            <a
              href="https://nasacademy.com/blog?s=crypto"
              rel="noopener noreferrer"
              target="_blank"
              className={`${classes.footerText} ${classes.socialLink} ${classes.footerTextSmall}`}
            >
              Resources
            </a>
          </div>
          <div>
            <a
              href="/privacy"
              rel="noopener noreferrer"
              target="_blank"
              className={`${classes.footerText} ${classes.socialLink} ${classes.footerTextSmall}`}
            >
              Privacy
            </a>
          </div>
        </div>
      )}
      <div className={`text-16 ${classes.footerTop}`}>
        <div className={classes.logo}>
          <Link to="/" aria-label={'Home'}>
            {lightTheme ? <LightLogo /> : <DarkLogo />}
          </Link>
        </div>
        <p className={classes.footerText}>Crypto for Nas Academy</p>
      </div>
      {isDesktopView && (
        <div className={classes.footerBottom}>
          <a
            href="https://nas-academy.gitbook.io/nas-io/"
            rel="noopener noreferrer"
            target="_blank"
            className={`${classes.footerText} ${classes.socialLink} ${classes.footerTextSmall}`}
          >
            Documentation
          </a>
          <div>
            <a
              href="https://nasacademy.com/blog?s=crypto"
              rel="noopener noreferrer"
              target="_blank"
              className={`${classes.footerText} ${classes.socialLink} ${classes.footerTextSmall}`}
            >
              Resources
            </a>
          </div>
          <div>
            <a
              href="/privacy"
              rel="noopener noreferrer"
              target="_blank"
              className={`${classes.footerText} ${classes.socialLink} ${classes.footerTextSmall}`}
            >
              Privacy
            </a>
          </div>
        </div>
      )}
      <div className={`text-16 ${classes.footerBottom}`}>
        <div className={classes.iconsContainer}>
          {socialLogos.map((logo, index) => (
            <div key={index} className={classes.socialLogo}>
              <a href={logo.link} rel="noopener noreferrer" target="_blank">
                {logo.logo}
              </a>
            </div>
          ))}
        </div>
        <div className={classes.copyRight}>Copyright © 2022</div>
        <div className={classes.copyRight}>
          Created by the team behind Nas Academy
        </div>
      </div>
    </footer>
  );
};

export default Footer;
